@if (hasMetrics()) {
  <div class="ai-metrics">
    @for (metric of metrics(); track $index) {
      <div class="ai-metrics__card">
        <div class="ai-metrics__label">{{ metric.label }}</div>
        <div class="ai-metrics__value">
          {{ metric.value }}
          @if (metric.trend) {
            <span
              class="ai-metrics__trend"
              [class.ai-metrics__trend--up]="metric.trend === 'up'"
              [class.ai-metrics__trend--down]="metric.trend === 'down'"
              >{{ trendIcon(metric.trend) }}</span
            >
          }
        </div>
        @if (metric.description) {
          <div class="ai-metrics__description">{{ metric.description }}</div>
        }
      </div>
    }
  </div>
}
